import { User } from './userType';

export const defaultUser: User = {
  given_name: null,
  family_name: null,
  handle: null,
  email: null,
  picture: null,
  id: null,
  token: null,
  provider: null
};